import {
  Facebook,
  Youtube, // 🟢 Replaced Twitter with Youtube
  Instagram,
  Linkedin,
  Mail,
  Phone,
  MapPin,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import newLogo from '../../assets/trueAdvisoLogo/trueAdvisologofull.jpeg'

export function Footer() {
  const footerLinks = {
    Platform: [
      { name: 'Browse Experts', path: '/experts' },
      { name: 'Categories', path: '/categories' },
      { name: 'How it Works', path: '/' },
    ],
    Company: [
      { name: 'About trueAdviso', path: '/about' },
      { name: 'Careers', path: '/careers' },
      { name: 'Blog', path: '/blogs' },
      { name: 'Contact Us', path: '/contact' },
    ],
    Support: [
      { name: 'Refund Policy', path: '/refund-policy' },
      { name: 'Terms & Conditions', path: '/terms' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'FAQs', path: '/faq' },
    ],
    'For Experts': [
      { name: 'Become an Expert', path: '/expert-signup' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 sm:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center mb-4">
              <div className="p-2 rounded-xl">
                <img
                  src={newLogo}
                  alt="True Adviso"
                  className="h-10 rounded-lg"
                />
              </div>
            </div>

            <p className="text-sm text-gray-400 mb-6 max-w-sm">
              Connect with verified experts for personalized guidance. Get expert
              consultation through chat, call, or video anytime, anywhere.
            </p>

            <div className="space-y-3">
              <a
                href="mailto:info@trueAdviso.com"
                className="flex items-center gap-3 text-sm hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 text-blue-400" />
                <span>info@trueAdviso.com</span>
              </a>

              <a
                href="tel:+918368832850"
                className="flex items-center gap-3 text-sm hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 text-blue-400" />
                <span>+91 8368832850</span>
              </a>

              <div className="flex items-start gap-3 text-sm">
                <MapPin className="w-4 h-4 text-blue-400 mt-0.5" />
                <span>
                  WZ-3437, 2nd Floor, Plot No.125, Raja Park, Rani Bagh,
                  Delhi-34
                </span>
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-white mb-4 text-sm sm:text-base">
                {title}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 my-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
          <p className="text-xs sm:text-sm text-gray-400 text-center md:text-left">
            © 2026 trueAdviso. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            {/* 🟢 NEW: Active Social Links */}
            <a 
              href="https://www.facebook.com/share/1B2QSzTXab/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer"
            >
              <Facebook className="w-5 h-5" />
            </a>
            
            <a 
              href="https://youtube.com/@trueadviso?si=BKEWtMKOsbPahSLb" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer"
            >
              <Youtube className="w-5 h-5" />
            </a>
            
            <a 
              href="https://www.instagram.com/trueadviso?utm_source=qr&igsh=MTNrOGdreWE2d2hscA%3D%3D" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors cursor-pointer"
            >
              <Instagram className="w-5 h-5" />
            </a>
            
            <a 
              href="https://www.linkedin.com/company/trueadviso/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6">
          <p className="text-xs text-gray-500 text-center">
            Disclaimer: trueAdviso is a platform connecting users with independent
            experts. The information provided is for general guidance only and
            should not be considered as professional advice.
          </p>
        </div>
      </div>
    </footer>
  );
}